import { RiTeamFill } from "react-icons/ri";

const pages = [
  {
    header: "ADMINISTRACIÓN DE USUARIOS",
  },
  {
    id: "users",
    title: "Usuarios",
    icon: <RiTeamFill set="curved" className="remix-icon" />,
    items: [
      {
        id: "usersNew",
        title: "Nuevo Usuario",
        navLink: "/admin/users/add-edit",
      },
      {
        id: "usersList",
        title: "Listado de Usuarios",
        navLink: "/admin/users/list",
      },
    ],
  },
];

export default pages;
